// Where this page is and what its URL and storage keys are called: read here once, by the head's boot script (boot.ts,
// bundled on its own before first paint) and by every module after it. It imports nothing, so boot.js stays small.

/** the current page's query, or "" off the browser (tests, node) */
const here = () => (typeof window !== "undefined" ? window.location.search : "");

/** `?name=1` or `?name=true` in the query */
export const flag = (name: string, search = here()) => new RegExp(`(?:[?&])${name}=(?:1|true)(?:&|$)`).test(search);

/** the broadcast (a ringside screen, the stream): only when this page's URL says so (`?broadcast=1`, `?tv=1`,
 * `?kiosk=1`), never a cookie or a storage flag: those once stuck for a year (boot.ts clears what is left of them) */
export const onBroadcast = (search = here()) => ["broadcast", "tv", "kiosk"].some((n) => flag(n, search));

/** the desktop app for Steam (#569, desktop/): its window names itself in its user agent, as the server reads it too
 * (src/web/layout.rs Visitor::app) */
export const onApp = () => typeof navigator !== "undefined" && navigator.userAgent.includes("basho-app/");

/** the show the query asks for this load (`?show=classic`), lower-case letters only */
export const showAsked = (search = here()) => /(?:[?&])show=([a-z]+)(?:&|$)/.exec(search)?.[1];

/** the viewer's choices in localStorage */
export const FONT_KEY = "basho.font";
export const THEME_KEY = "basho.theme";
/** the show: "stage", the arena, the figures and the ceremony (the default); "classic", the flat ring, nothing moving */
export const SHOW_KEY = "basho.show";
/** the animations: on unless the viewer turned them off ("0"); the os's reduced-motion setting also turns them off */
export const MOTION_KEY = "basho.motion";
/** the tv's panel as the viewer left it (panelui.ts) */
export const PANEL_KEY = "basho.panel";
